import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6228b7e6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "tree-menu",
    style: {top: _ctx.position.top + 'px', left: _ctx.position.left + 'px'}
  }, [
    _createVNode("li", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('rename')))
    }, _toDisplayString(_ctx.isOffice ? _ctx.$wordList.ListInHtmlModify : _ctx.$wordList.ListInHtmlRename), 1),
    _createVNode("li", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete')))
    }, _toDisplayString(_ctx.$wordList.ListInHtmlDelete), 1)
  ], 4))
})